import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SchemaIndicatif.module.css';

/**
 * Schéma indicatif d'un écran à venir : le MÊME pour tous les modules — un
 * cadre, une barre, une grille de blocs et un panneau latéral, en gris. Il dit
 * qu'un écran existera, pas à quoi il ressemblera : aucun texte, aucun chiffre,
 * aucune donnée.
 */
export function SchemaIndicatif(): JSX.Element {
  const { t } = useTranslation('regie');
  return (
    <figure className={styles.schema} data-ui="module-schema">
      <div className={styles.cadre} role="img" aria-label={t('modulesAVenir.fiche.schemaAria')}>
        <div className={styles.barre}>
          <span className={styles.titre} />
          <span className={styles.bouton} />
        </div>
        <div className={styles.corps}>
          <div className={styles.grille}>
            {[0, 1, 2, 3, 4, 5].map((index) => (
              <span key={index} className={styles.bloc}>
                <span className={styles.image} />
                <span className={styles.legende} />
              </span>
            ))}
          </div>
          <div className={styles.panneau}>
            <span className={styles.trait} />
            <span className={styles.traitCourt} />
            <span className={styles.interrupteur} />
            <span className={styles.traitCourt} />
          </div>
        </div>
        <span className={styles.pied} />
      </div>
      <figcaption>{t('modulesAVenir.fiche.schemaLegende')}</figcaption>
    </figure>
  );
}
